import { latestArticles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function LatestArticles() {
  const displayArticles = latestArticles.slice(0, 6);

  return (
    <section className="bg-background-100/50 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 mb-5">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-flashlight-fill text-primary-600 text-xs"></i>
            </span>
            <span className="text-xs font-medium text-primary-700 tracking-wide">最新爆料</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            最新<span className="text-primary-600">爆料</span>流
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            第一时间获取真实及时的独家内幕
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}